import React from "react"
import { Form } from "react-bootstrap"
import PropTypes from "prop-types"

export const FormErrorFeedback = ({ meta }) => {
  if (!meta.touched || !meta.error) return null

  return (
    <Form.Control.Feedback type="invalid" className="mt-1">
      {meta.error}
    </Form.Control.Feedback>
  )
}

FormErrorFeedback.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
}
